var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    staticClass: "q-mt-xs",
    attrs: {
      data: _vm.data,
      columns: _vm.columns,
      pagination: _vm.server_pagination,
      loading: _vm.loading,
      filter: _vm.filter,
      "row-key": "name",
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.server_pagination = $event
      },
      request: _vm.request
    },
    scopedSlots: _vm._u([
      {
        key: "top",
        fn: function(props) {
          return [
            _c("q-search", {
              attrs: {
                icon: "fas fa-search",
                placeholder: _vm.$t("search"),
                debounce: 500
              },
              model: {
                value: _vm.filter,
                callback: function($$v) {
                  _vm.filter = $$v
                },
                expression: "filter"
              }
            })
          ]
        }
      },
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v("\n\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t")
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            [
              _c("q-td", { key: "full_name", attrs: { props: props } }, [
                _vm._v("\n\t\t\t" + _vm._s(props.row.full_name) + "\n\t\t")
              ]),
              _c("q-td", { key: "profile", attrs: { props: props } }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.translateProfiles(props.row.profile)) +
                    "\n\t\t"
                )
              ]),
              _c("q-td", { key: "email", attrs: { props: props } }, [
                _vm._v("\n\t\t\t" + _vm._s(props.row.email) + "\n\t\t")
              ]),
              _c(
                "q-td",
                { key: "status", attrs: { "auto-width": "", props: props } },
                [
                  _c(
                    "q-chip",
                    {
                      staticClass: "full-width",
                      attrs: {
                        small: "",
                        icon: _vm.getIconStatus(props.row.status),
                        color: _vm.getColorStatus(props.row.status)
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }